const { BaseClient } = require('../shared')

const handle404Error = (e) => {
    try {
        if (e.response.status.toString() === "404") {
            return [];
        }
    } catch (e2) {
        console.log("ORIGINAL ERROR THROWING CATCH ERROR:", e);
        throw (e2);
    }
}

class ReferralClient extends BaseClient {
    constructor(
        referralServiceUrl = process.env.REFERRAL_URL || process.env.REACT_APP_REFERRAL_URL,
        referralServiceSecretName = process.env.CENTIVO_REFERRAL_SECRET_NAME || 'referral-system-broker-service-key',
        axiosOptions
    ) {
        super(referralServiceUrl, referralServiceSecretName, axiosOptions)
    }

    async getReferralsById(referralUuid) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsById`, {
                params: {
                    referralUuid: referralUuid
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }
    
    async getReferralsByPatientId(patientUuid, dateFrom, dateTo, lastEvalKey, usePagination) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByPatientId`, {
                params: {
                    patientUuid: patientUuid,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    lastEvalKey,
                    usePagination
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }
    
    async getReferralsByProviderUserEmail(email) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByProviderUserEmail`, {
                params: {
                    email: email
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }

    async getReferralsByReferredTin(tins, page, dateFrom = null, dateTo = null, pageSize = null) {
        await this.createSecureAxiosInstance();

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByReferredTin`, {
                params: {
                    tins,
                    page,
                    dateFrom,
                    dateTo,
                    pageSize
                }
            })

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } 
        catch (e) {
            return handle404Error(e);
        }
    }
    
    async getReferralsByReferredByTinPagination(tin, dateFrom, dateTo, paginate = true, lastEvalKey = null) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByReferredByTinPagination`, {
                params: {
                    tin: tin,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    paginate: paginate,
                    lastEvalKey: lastEvalKey
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }
    
    async getReferralsByReferredByTin(tin, dateFrom, dateTo) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByReferredByTin`, {
                params: {
                    tin: tin,
                    dateFrom: dateFrom,
                    dateTo: dateTo
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }
    
    async getReferralsByReferredToTinPagination(tin, dateFrom, dateTo, paginate = true, lastEvalKey = null) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByReferredToTinPagination`, {
                params: {
                    tin: tin,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    paginate: paginate,
                    lastEvalKey: lastEvalKey
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }
    
    async getReferralsByReferredToTin(tin, dateFrom, dateTo) {
        await this.createSecureAxiosInstance()

        let response = null;
        try {
            response = await this.secureAxiosInstance.get(`getReferralsByReferredToTin`, {
                params: {
                    tin: tin,
                    dateFrom: dateFrom,
                    dateTo: dateTo
                }
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            return handle404Error(e);
        }
    }
    
    /**
     * @param {*} referral 
     * @param {*} member 
     * @param {*} referredByCarepoint 
     * @param {*} referredToCarepoint 
     * @param {*} secondaryReferredToCarepointsList 
     */
    async submitReferral(referral, member, referredByCarepoint, referredToCarepoint, secondaryReferredToCarepointsList) {
        await this.createSecureAxiosInstance()

        try {
            const response = await this.secureAxiosInstance.post(`submitReferral`, {
                referral: referral,
                member: member,
                referredByCarepoint: referredByCarepoint,
                referredToCarepoint: referredToCarepoint,
                secondaryReferredToCarepointsList: secondaryReferredToCarepointsList
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            throw e;
        }
    }
    
    /**
     * 
     * @param {string} referralUuid 
     * @param {string} referralReason 
    *  @param {number} referralDurationDays
     * @returns 
     */
    async extendReferral(referralUuid, referralReason, referralDurationDays = undefined) {
        await this.createSecureAxiosInstance()

        try {
            const response = await this.secureAxiosInstance.post(`extendReferral`, {
                referralUuid,
                referralReason,
                referralDurationDays,
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            throw e;
        }
    }
    
    /**
     * @param {*} referralUuid 
     * @param {*} expirationDate 
     */
    async updateReferralExpiration(referralUuid, expirationDate) {
        await this.createSecureAxiosInstance()

        try {
            const response = await this.secureAxiosInstance.put(`updateReferralExpiration`, {
                referralUuid: referralUuid,
                expirationDate: expirationDate
            });

            if (response.status !== 200) {
                return null;
            }

            return response.data;
        } catch (e) {
            throw e;
        }
    }
}

module.exports = {
    ReferralClient
}